import {
  Accessories,
  AccessoryDetails,
  AdminLogs,
  AssetDetails,
  AssetStatuses,
  Assets,
  AssetTypes,
  Emails,
  Home,
  Locations,
  NotFound,
  Notifications,
  ReportDetails,
  Reports,
  ScannerLog,
  Settings,
  TaxStatus,
  Unauthorized,
  UserDetails,
  Users,
} from '@Pages/index.ts';
import AssetTemplates from '@Pages/Settings/AssetTemplates/AssetTemplates.tsx';
import { ADMIN_ROLES, PATHS } from '@Utils/constants';
import { Route, Routes } from 'react-router-dom';
import { PrivateRoute } from './PrivateRoute.tsx';
import ProtectedRoutes from './ProtectedRoutes.tsx';

const {
  HOME,
  ASSETS,
  ASSET_DETAILS,
  ASSET_STATUS,
  ASSET_TEMPLATES,
  ASSET_TYPES,
  EMAIL,
  LOCATIONS,
  REPORTS,
  USERS,
  SETTINGS,
  NOTFOUND,
  TAX_STATUS,
  UNAUTHORIZED,
  SCANNER_LOG,
  ADMIN_LOG,
  NOTIFICATIONS,
  REPORT_DETAILS,
  ACCESSORY_SETTINGS,
  ACCESSORY_DETAILS,
  USER_DETAILS,
} = PATHS;

const AppRoutes = () => (
  <Routes>
    <Route path={UNAUTHORIZED} element={<Unauthorized />} />
    <Route element={<ProtectedRoutes />}>
      <Route
        path={HOME}
        element={
          <PrivateRoute roles={ADMIN_ROLES} redirect={<Assets />}>
            <Home />
          </PrivateRoute>
        }
      />
      <Route path={ASSET_DETAILS} element={<AssetDetails />} />
      <Route path={ACCESSORY_DETAILS} element={<AccessoryDetails />} />
      <Route path={ASSETS} element={<Assets />} />
      <Route
        path={REPORTS}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <Reports />
          </PrivateRoute>
        }
      />
      <Route path={REPORT_DETAILS} element={<ReportDetails />} />
      <Route
        path={SCANNER_LOG}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <ScannerLog />
          </PrivateRoute>
        }
      />
      <Route
        path={ASSET_STATUS}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <AssetStatuses />
          </PrivateRoute>
        }
      />
      <Route
        path={TAX_STATUS}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <TaxStatus />
          </PrivateRoute>
        }
      />
      <Route
        path={LOCATIONS}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <Locations />
          </PrivateRoute>
        }
      />
      <Route
        path={ASSET_TYPES}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <AssetTypes />
          </PrivateRoute>
        }
      />
      <Route
        path={EMAIL}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <Emails />
          </PrivateRoute>
        }
      />
      <Route
        path={SETTINGS}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <Settings />
          </PrivateRoute>
        }
      />
      <Route path={NOTFOUND} element={<NotFound />} />
      <Route
        path={USERS}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        path={ADMIN_LOG}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <AdminLogs />
          </PrivateRoute>
        }
      />
      <Route
        path={NOTIFICATIONS}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <Notifications />
          </PrivateRoute>
        }
      />
      <Route
        path={ACCESSORY_SETTINGS}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <Accessories />
          </PrivateRoute>
        }
      />
      <Route
        path={ASSET_TEMPLATES}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <AssetTemplates />
          </PrivateRoute>
        }
      />
      <Route
        path={USER_DETAILS}
        element={
          <PrivateRoute roles={ADMIN_ROLES}>
            <UserDetails />
          </PrivateRoute>
        }
      />
    </Route>
  </Routes>
);

export default AppRoutes;
